export const columns = function () {
  // 服务单号，机构名称，车牌号，服务起期，服务止期，应收差额（元），净费差额（元），实收差额（元），修改明细，制单人，创建时间，审核人，审核时间，财务审核，财务审核时间，备注
  return [
    {
	  prop: "insBillId",
	  label: "流水号",
	  minWidth: 200,
    },
    {
      prop: "bh",
      label: "服务单号",
      minWidth: 200,
    },
    {
      prop: "orgName",
      label: "机构名称",
      minWidth: 100,
    },
    {
      prop: "carNo",
      label: "车牌号",
      minWidth: 100,
    },
    {
      prop: "beginTime",
      label: "服务起期",
      minWidth: 100,
    },
    {
      prop: "endTime",
      label: "服务止期",
      minWidth: 100,
    },
	{
	  prop: "payTime",
	  label: "实际支付时间",
	  minWidth: 100,
	},
    {
      prop: "yjtcfee",
      label: "应收差额（元）",
      minWidth: 100,
    },
    {
      prop: "netFee",
      label: "净费差额（元）",
      minWidth: 100,
    },
    {
      prop: "actualFee",
      label: "实收差额（元）",
      minWidth: 100,
    },
    {
      prop: "piwen",
      label: "修改明细",
      minWidth: 100,
      slotName: "piwen",
    },
    {
      prop: "CreatorName",
      label: "制单人",
      minWidth: 100,
    },
    {
      prop: "create_time",
      label: "创建时间",
      minWidth: 100,
    },
    {
      prop: "auditName",
      label: "审核人",
      minWidth: 100,
    },
    {
      prop: "auditTime",
      label: "审核时间",
      minWidth: 100,
    },
    {
      prop: "fauditName",
      label: "财务审核",
      minWidth: 100,
    },
    {
      prop: "fauditTime",
      label: "财务审核时间",
      minWidth: 100,
    },
    {
      prop: "pd_remark",
      label: "备注",
      minWidth: 100,
    },
  ];
};

export default {};
